<template>
  <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="56" height="56" fill="none" viewBox="0 0 56 56">
    <title>Small illustration of a dog with magenta leash</title>
    <path
      fill-rule="evenodd"
      stroke="#05070F"
      stroke-linejoin="round"
      stroke-width="2"
      d="M25.156 22.04l-4.05-9.744s-1.648-5.964-7.338-5.234l1.569 4.998s-10.956.768-11.84 1.534c-.883.766-.167 7.416 8.852 8.718l.791 3.505S16.457 51.09 17.148 53c.69 1.91 4.938.852 4.938-.62 0-1.474-2.373-10.705 1.124-16.583.227-.38-3.523 6.193 0 6.193 13.157 0 16.461-6.605 16.983-6.193.874.693 1.794 15.748 2.557 17.202.763 1.454 3.313 2.001 4.208.001-.98-13.253-1.494-23.341-1.494-23.341 4.383-.434 8.04-9.35 8.04-11.53 0 0-4.575 5.385-8.04 6.627-2.589.928-9.281.735-9.281.735h-5.595c-1.732-.118-3.643-.737-5.432-3.45z"
      clip-rule="evenodd"
    />
    <path stroke="#05070F" stroke-linecap="round" stroke-width="2" d="M26.136 20.236L11.713 25.69" />
    <path
      stroke="#FF0064"
      stroke-linecap="round"
      stroke-width="2"
      d="M43.64 6.838s1.814 4.056 4.8 4.056c2.986 0 7.323-3.673 4.392-4.964-2.932-1.29-8.082-.604-12.374 1.45-4.292 2.052-11.168 9.81-11.168 9.81"
    />
    <path
      fill="#05070F"
      fill-rule="evenodd"
      d="M13.473 14.034c.533.143.85.69.706 1.224-.144.533-.693.85-1.226.708-.534-.143-.85-.69-.707-1.224.144-.533.693-.85 1.226-.708zM3.514 13.622l3.109-.479s-.015 1.159-.462 1.9c-.448.74-1.612 1.535-1.612 1.535l-1.035-2.956z"
      clip-rule="evenodd"
    />
  </svg>
</template>

<script lang="ts">
export default {
  name: 'PetCareIcon',
};
</script>
